// helpers/rutaTransportes.js
import axios from "axios";

// Base por ENV o fallback a San Pancracio
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, ""); // sin slash final

// Instancia axios
const API = axios.create({ baseURL: BASE_URL });

// Arma paths sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// Headers con token (Content-Type solo cuando hace falta)
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// (Opcional) log de URL efectiva
const debugUrl = (url) => console.log("👉 URL:", API.getUri({ url }));

// --------- TRANSPORTES ---------
export const getTransportes = async () => {
  const url = p("transportes");
  debugUrl(url);
  const { data } = await API.get(url, auth());
  // Normaliza: { ok, transportes:[...] } o array directo
  return Array.isArray(data?.transportes) ? data.transportes : (Array.isArray(data) ? data : []);
};

export const getTransporteById = async (id) => {
  const url = p(`transportes/${id}`);
  debugUrl(url);
  const { data } = await API.get(url, auth());
  return data; // { ok:true, transporte:{...} } típicamente
};

export const postTransporte = async (payload) => {
  const url = p("transportes");
  debugUrl(url);
  const { data } = await API.post(url, payload, auth());
  return data; // { ok:true, transporte:{...} }
};

export const putTransporte = async (id, payload) => {
  const url = p(`transportes/${id}`);
  debugUrl(url);
  const { data } = await API.put(url, payload, auth());
  return data;
};

export const deleteTransporte = async (id) => {
  const url = p(`transportes/${id}`);
  debugUrl(url);
  const { data } = await API.delete(url, auth());
  return data;
};
